import { useCallback } from 'react';
import { wrapNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';

export const NotificationPermissionPage = wrapNavigatorScreen(
  () => {
    return null;
  },
  {
    cardOverlayEnabled: true,
    animationEnabled: false,
    detachPreviousScreen: false,
    cardStyle: {
      backgroundColor: 'transparent',
    },
    headerShown: false,
  },
);

export function useNotificationModal() {
  return useCallback(() => {}, []);
}

export namespace useNotificationModal {
  export const optsForSeller = () => ({ image: <div />, description: '' });
}

export const WiredNotificationModal = () => {
  return null;
};
